var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col"},[_c('span',{staticClass:"text-xs-center margin-auto primary--text",attrs:{"bottom":""}},[_c('i',{staticClass:"v-icon material-icons primary--text",attrs:{"aria-hidden":"true"}},[_vm._v("\n      "+_vm._s(_vm.inPartListBasket(_vm.part) ? 'check_box'
            : 'check_box_outline_blank')+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }